import React from 'react'

import DashboardCard from '../DashboardCard/DashboardCard';

import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import FullMessageOverlay from '../FullMessageOverlay/FullMessageOverlay';
import ErrorOverlay from "../ErrorOerlay/ErrorOerlay";

import css from './CompanyCard.module.css'
import Tooltip from '@/shared/components/organism/Tooltip/Tooltip';

type CompanyCardProps = {
  title: string;
  col: number;
  row: number;

  loading: boolean;
  error: string | null;
  fullMessage?: string;

  target: number | undefined;
  /** Факт (value), отображается как «Факт» */
  value: number | undefined;
  /** Факт к отгрузке */
  valuePreparation?: number | null;
  precent: number | undefined;
  /** Заплачено из факта выполнения */
  paid?: number;
  /** Факт за прошлый период */
  lastPeriod?: { value: number };
  /** Прогноз значения на конец периода */
  trend?: { value: number };
  /** Сумма прогнозов компании за период */
  forecastValue?: number | null;
  /** Плановые продажи (сумма или прибыль — в зависимости от карточки) */
  plannedSalesValue?: number | null;
  plannedSalesLabel?: string;

  setOpenPopup?: () => void
}

const CompanyCard: React.FC<CompanyCardProps> = ({
  title,
  col,
  row,

  loading,
  error,
  fullMessage,

  target,
  value,
  valuePreparation,
  precent,
  paid,
  lastPeriod,
  trend,
  forecastValue,
  plannedSalesValue,
  plannedSalesLabel = "Плановые продажи",

  setOpenPopup
}) => {

  return (
    <DashboardCard col={col} height={row*50} rowSpan={row} title={title} isHover onClick={setOpenPopup}>
      {loading ? (
        <LoadingOverlay loading />
      ) : error ? (
        <ErrorOverlay error={error} />
      ) : fullMessage ? (
        <FullMessageOverlay fullMessage={fullMessage} />
      ) : (target != null && value != null && precent != null) ? (
        <React.Fragment>
          <div className={css.plan__section}>
            <div className={css.plan__item}>
              <div className={css.item__title}>План</div>
              <div className={css.item__value}>{target.toLocaleString()} ₽</div>
              {forecastValue != null && (
                <div className={css.item__forecast}>
                  Прогноз компании: {forecastValue.toLocaleString("ru-RU")} ₽
                </div>
              )}
              {plannedSalesValue != null && (
                <div className={css.item__plannedSales}>
                  {plannedSalesLabel}: {plannedSalesValue.toLocaleString("ru-RU")} ₽
                </div>
              )}
              <div className={css.item__title}></div>
            </div>
            <div className={css.plan__item}>
              <div className={css.item__title}>Факт</div>
              <div className={css.item__value}>{value.toLocaleString()} ₽</div>
              {valuePreparation != null && (
                <div className={css.item__preparation}>
                  К отгрузке: {valuePreparation.toLocaleString("ru-RU")} ₽
                </div>
              )}
              {trend != null && (
                <div className={css.item__trend}>
                  Тренд на конец периода: {trend.value.toLocaleString("ru-RU", {
                    maximumFractionDigits: 1,
                  })} ₽
                </div>
              )}
              <div className={css.item__completion}>{precent.toFixed(1)}% выполнения</div>
            </div>
            {lastPeriod != null && (
              <div className={css.plan__item}>
                <Tooltip text="Факт за прошлый период">
                  <div className={css.item__title}>Прошлый период</div>
                </Tooltip>
                <div className={css.item__value}>{lastPeriod.value.toLocaleString()} ₽</div>
                <div className={css.item__completion}>
                  {lastPeriod.value === 0
                    ? '—'
                    : (() => {
                        const diffPercent = ((value! - lastPeriod.value) / lastPeriod.value) * 100
                        const sign = diffPercent > 0 ? '+' : diffPercent < 0 ? '-' : ''
                        const abs = Math.abs(diffPercent).toFixed(1)
                        const text = diffPercent > 0
                          ? `${abs}% больше`
                          : diffPercent < 0
                            ? `${abs}% меньше`
                            : 'без изменений'
                        return `${sign} ${text}`.trim()
                      })()}
                </div>
              </div>
            )}
          </div>
          <div className={css.progress}>
            <div
              className={css.progress__fill}
              style={{ width: `${Math.min(precent, 100)}%` }}
            />
          </div>
          <div className={css.progressInfo}>
            <div className={css.progressInfo__item}>
              <span className={css.item__title}>Осталось до выполнения:</span>
              <span className={css.progressInfo__value}>{Number(
                Math.max(target - value, 0)
              ).toLocaleString()} ₽</span>
            </div>
            {paid != null && (
              <div className={css.progressInfo__item}>
                <span className={css.item__title}>Заплачено из факта:</span>
                <span className={css.progressInfo__value}>
                  {paid.toLocaleString()} ₽
                  {value != null && value > 0 ? ` (${((paid / value) * 100).toFixed(1)}% от факта)` : ''}
                </span>
              </div>
            )}
          </div>
        </React.Fragment>
      ) : (
        <FullMessageOverlay fullMessage='Нет данных' />
      )}
    </DashboardCard>
  )
}

export default CompanyCard